export const smsbWidgetInit = () => {
  // variables
  if (!window.zE) {
    console.error("Failed to init zendesk widget for SMSB");
    return;
  }
  window.zEConfigVariables = {
    // scope to only the following Chat departments
    open: {
      days: [1, 2, 3, 4, 5],
      hours: [9, 10, 11, 12, 13, 14, 15, 16],
      timezone: "Australia/Sydney",
    },
  };

  window.zE("webWidget:on", "chat:connected", chatConnected);

  function chatConnected() {
    updateChatVisibility();
    window.zE?.("webWidget:on", "chat:departmentStatus", updateChatVisibility);
  }

  function updateChatVisibility() {
    if (!window.zE) {
      console.error("Failed to init zendesk widget for SMSB");
      return;
    }
    const departmentsOnline = enabledDepartmentsAreOnline();
    if (departmentsOnline) {
      window.zE("messenger", "show");
    } else {
      window.zE("messenger", "hide");
    }
    window.zE("webWidget", "updateSettings", {
      webWidget: {
        chat: {
          suppress: !departmentsOnline,
        },
      },
    });
  }

  function enabledDepartmentsAreOnline() {
    if (!window.zE) {
      console.error("enabledDepartmentsAreOnline Failed");
      return;
    }
    const departments = window.zE("webWidget:get", "chat:departments");
    let numOfEnabledDepartmentsOnline = 0;
    console.log("Department Online:", departments);
    const currentDate = new Date(
      new Date().toLocaleString("en-US", {
        timeZone: window.zEConfigVariables?.open.timezone,
      })
    );
    const hour = currentDate.getHours();
    const day = currentDate.getDay();
    const nowIsOpenDay =
      (window.zEConfigVariables?.open?.days?.indexOf(day) || -1) > -1;
    const nowIsOpenHour =
      (window.zEConfigVariables?.open?.hours?.indexOf(hour) || -1) > -1;
    console.log("Date", nowIsOpenHour);

    departments.forEach((department) => {
      if (nowIsOpenDay && nowIsOpenHour && department.status === "online") {
        numOfEnabledDepartmentsOnline++;
      }
    });
    return numOfEnabledDepartmentsOnline > 0;
  }

  window.zESettings = {
    webWidget: {
      chat: {
        departments: {
          enabled: [],
        },
      },
    },
  };
};
